import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import styled from 'styled-components';
import Styles from './Experience.styles';
import Text from '../../base/Text';
import ExperienceCard from '../../base/ExperienceCard';
import { getKey } from '../../../helpers';
import SelectCategory from '../../base/SelectCategory';
import translationsOptions from './data/translations';
import CategoriesButtons from '../CategoriesButtons';

const Title = styled(Text)`${Styles.title}`;
const Subtitle = styled(Text)`${Styles.subtitle}`;
const CategoriesWrapper = styled.div`${Styles.categoriesWrapper}`; // prettier-ignore
const Categories = styled.div`${Styles.categories}`; // prettier-ignore
const Wrapper = styled.div`${Styles.wrapper}`; // prettier-ignore
const Fluidwrapper = styled.div`${Styles.fluidwrapper}`; // prettier-ignore
const Categoriesmenu = styled.div`${Styles.categoriesmenu}`; // prettier-ignore

const CardWrappers = ['col-12', 'col-12 col-md-4', 'col-12 col-md-8', 'col-12 col-md-8', 'col-12 col-md-4'];
const cardsColors = ['pink', 'aqua', 'yellow', 'purple', 'green'];
/**
 * Experience componente
 */
class Experience extends PureComponent {
  static propTypes = {
    articles: PropTypes.array,
    categories: PropTypes.array,
    tags: PropTypes.array,
    locale: PropTypes.string,
    base: PropTypes.string,
    category: PropTypes.object,
    tag: PropTypes.object
  };

  /**
   * Redirect to a given slug
   * @param {string} locale language identifier
   * @param {string} slug slug for the category
   */
  static redirect(locale, slug) {
    const url = slug;
    navigate(url);
  }

  /**
   * Constructor method
   * @param {Object} props of the component
   */
  constructor(props) {
    super(props);
    this.state = {
      translations: getKey(translationsOptions, props.locale)
    };
  }

  /**
   * render method
   * @returns {JSX}
   */
  render() {
    const {
      articles,
      locale,
      categories,
      tags,
      tag,
      category,
      base
    } = this.props;
    const {
      translations: { title, subtitle }
    } = this.state;

    const elements = articles;
    const selectedCategory = category !== null ? `${base}${category.slug}` : null;

    const selectedTag = tag !== null ? `${base}${tag.slug}` : null;

    let categoriesPills = [];
    const categorypills = categories.map(cat => ({
      titlebutton: cat.label,
      link: cat.value,
      key: cat.key,
      activebutton: category !== null ? category.id === cat.key : false
    }));
    categoriesPills = [
      {
        titlebutton: locale === 'en' ? 'All' : 'Todas',
        link: base,
        key: 'all_categories',
        activebutton: category === null
      },
      ...categorypills
    ];
    return (
      <Wrapper>
        <Fluidwrapper>
          <div className="row">
            <div className="col-md-12">
              <Title tag="h3" className="cbx-bold">
                {title}
              </Title>
              <Subtitle tag="h4" className="cbx-bold">
                {subtitle}
              </Subtitle>
            </div>
          </div>
          <CategoriesWrapper>
            <div className="row">
              <div className="col-6 col-sm-12 col-md-10">
                <Categoriesmenu>
                  <SelectCategory
                    onChange={event => Experience.redirect(locale, event.target.value)}
                    options={categories}
                    selected={selectedCategory}
                    placeholder={{
                      value: locale === 'es' ? '/es/experience' : '/en/experience',
                      label:
                        locale === 'es'
                          ? 'Todas las categorías'
                          : 'All categories'
                    }}
                  />
                </Categoriesmenu>
                <Categories>
                  <CategoriesButtons items={categoriesPills} />
                </Categories>
              </div>
              <div className="col-6 col-sm-12 col-md-2">
                <SelectCategory
                  onChange={event => Experience.redirect(locale, event.target.value)}
                  options={tags}
                  selected={selectedTag}
                  placeholder={{
                    value: locale === 'es' ? '/es/experience' : '/en/experience',
                    label:
                      locale === 'es' ? 'Todos los temas' : 'All topics'
                  }}
                />
              </div>
            </div>
          </CategoriesWrapper>
        </Fluidwrapper>
        <Fluidwrapper>
          <div className="row">
            {elements.map((item, index) => {
              const { node } = item;
              return (
                <div
                  key={getKey(node, 'key')}
                  className={CardWrappers[index]}
                >
                  <ExperienceCard
                    gradientColor={cardsColors[index % 5]}
                    height={1}
                    locale={locale}
                    id={getKey(node, 'id')}
                    slug={getKey(node, 'slug')}
                    title={getKey(node, `title_${locale}`)}
                    image={getKey(node, 'image.childImageSharp.fluid')}
                    content={getKey(item, `node.review_${locale}`)}
                  />
                </div>
              );
            })}
          </div>
        </Fluidwrapper>
      </Wrapper>
    );
  }
}

export default Experience;
